import { Spinner } from '@app/components/icons/spinner';
import React from 'react';

export const LoadingFallback = () => {
  return (
    <div className="flex w-full justify-center items-center h-full py-8">
      <Spinner size="large" className="text-blue-500" showLabel />
    </div>
  );
};
